import styled, { css } from 'styled-components';
import { StyledCard } from '../../../../components/card/ui';
import breakpoints from '../../../../utilities/breakpoints';

export const Container = styled.div`
    font-size: 16px;

    & .ant-pro-page-container-children-content {
        margin: 0;
    }

    @media screen and (min-width: 1272px) {
        max-width: 1200px;
        margin: 0 auto;
        padding: 0;
    }
`;

export const PageTitle = styled.div`
    font-size: 32px;
    text-align: left;
    padding: 94px 24px 55px;

    & strong {
        font-weight: 900;
    }

    @media screen and (max-width: ${breakpoints.md}) {
        margin-bottom: 20px;
        border-bottom: 4px solid #ddda3f;
        padding: 8px 24px 28px;
    }

    .ant-typography {
        margin: 0;
    }
`;

export const StyledVehicleCard = styled(StyledCard)`
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    .ant-card-cover {
        overflow: hidden;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        margin: 0;

        img {
            height: auto;
            width: 100%;
            aspect-ratio: 16/9;
            object-fit: cover;
            object-position: center center;
        }
    }

    .ant-card-body {
        padding: 30px 24px;

        @media screen and (max-width: ${breakpoints.md}) {
            padding: 29px 24px 22px;
        }
    }

    .ant-card-meta-title {
        font-size: 28px;
        line-height: 35px;
        color: #000;
        margin-bottom: 14px;

        @media screen and (max-width: ${breakpoints.md}) {
            font-size: 20px;
            margin-bottom: 13px;
            line-height: 24px;
        }
    }

    .ant-card-meta-detail > div:not(:last-child) {
        margin-bottom: 14px;

        @media screen and (max-width: ${breakpoints.md}) {
            margin-bottom: 13px;
        }
    }

    .ant-card-meta-description {
        font-size: 16px;
        line-height: 19px;
        font-weight: 900;
        color: #000000;
    }

    .ant-card-actions {
        margin-top: auto;
        padding-top: 200px;
        border-top: 0;
        padding: 0 24px;
        border-bottom-right-radius: 8px;
        border-bottom-left-radius: 8px;
        & > li {
            margin-top: 2px;
            margin-bottom: 24px;

            .ant-space {
                display: flex;
                width: 100%;

                .ant-space-item {
                    width: 50%;
                }
            }
        }
    }
`;

export const StyledListWrapper = styled.div`
    padding: 40px 24px;

    .ant-list-grid .ant-col {
        height: 100%;

        > .ant-list-item {
            height: 100%;
            padding-bottom: 40px;
            margin: 0;
            @media screen and (max-width: ${breakpoints.md}) {
                padding-bottom: 24px;
            }
            > .ant-card {
                height: 100%;
            }
        }
    }
`;

export const FilterContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    padding: 0 24px;
`;

export const FilterItem = styled.div<{ right?: boolean }>`
    @media screen and (max-width: ${breakpoints.md}) {
        flex: 1 1 100%;
        width: 100%;

        &:first-child {
            margin-bottom: 32px;
        }
    }

    .ant-space {
        .ant-btn {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        @media screen and (max-width: ${breakpoints.md}) {
            display: flex;
            gap: 4px !important;

            .ant-space-item {
                flex-wrap: nowrap;

                &:first-child {
                    flex: 1 1 84px;
                }
                &:last-child {
                    flex: 1 1 calc(100% - 84px);
                }

                .ant-btn {
                    padding-left: 20px;
                    padding-right: 20px;
                }
            }
        }

        &:not(:last-child) {
            margin-right: 17px;
            margin-bottom: 0;

            @media screen and (max-width: ${breakpoints.md}) {
                margin-right: 0;
                margin-bottom: 16px;
            }
        }
    }

    ${props =>
        props.right &&
        css`
            margin-left: auto;
            @media screen and (max-width: ${breakpoints.md}) {
                margin-left: 0;
                flex: 1 1 100%;
                width: 100%;
            }
        `}
`;

export const StyledLabelContainer = styled.div<{ isLabel: boolean }>`
    display: table;
    margin-top: 10px;
    margin-bottom: 5px;

    ${props =>
        props.isLabel &&
        css`
            height: 25px;
        `}
`;

export const StyledFilterButton = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
`;
